import { useContext, ComponentType, PropsWithChildren } from "react";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import { UserContext } from "@app/user/UserContext";
import { isNetworkPortfolioManagementEligible, networkPortfolioManagementViewStorageKey } from "@app/shared/network-portfolio-management/utility";
import { NPM_DASHBOARD_VIEW_NEW } from "@app/shared/network-portfolio-management/constants";

export interface IsNPMDashboardActiveProps {
  isNPMDashboardActive: boolean;
}

const useIsNPMDashboardActive = (): boolean => {
  const user = useContext(UserContext);
  const featureFlags = useContext(FeatureFlagContext);

  if (!user) {
    return false;
  }

  return isNetworkPortfolioManagementEligible(featureFlags.enabledFeatureFlags, user.roles)
    && localStorage.getItem(networkPortfolioManagementViewStorageKey(user)) === NPM_DASHBOARD_VIEW_NEW;
};

export default useIsNPMDashboardActive;

export function withIsNPMDashboardActive<T>(Component: ComponentType<PropsWithChildren<T & IsNPMDashboardActiveProps>>): ComponentType<PropsWithChildren<T>> {
  return function WrappedComponent(props) {
    const isNPMDashboardActive = useIsNPMDashboardActive();
    return <Component {...props} {...{['isNPMDashboardActive']: isNPMDashboardActive}} />;
  };
}
